/**
 * Platform-owned module catalog.
 * Organization activation is handled separately via organization assignments.
 */
export const PLATFORM_MODULE_REGISTRY = {
    PLATFORM: {
        id: 'PLATFORM',
        name: 'Platform',
        globallyAvailable: true,
        licensable: false,
        configurableByOrganization: false,
    },
    AUTH: {
        id: 'AUTH',
        name: 'Authentication',
        globallyAvailable: true,
        licensable: false,
        configurableByOrganization: false,
    },
    DASHBOARD: {
        id: 'DASHBOARD',
        name: 'Dashboard',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    SETTINGS: {
        id: 'SETTINGS',
        name: 'Settings',
        globallyAvailable: true,
        licensable: false,
        configurableByOrganization: true,
    },
    NAVIGATION: {
        id: 'NAVIGATION',
        name: 'Navigation',
        globallyAvailable: true,
        licensable: false,
        configurableByOrganization: false,
    },
    INVESTMENT: {
        id: 'INVESTMENT',
        name: 'Investment',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    ACCOUNTING: {
        id: 'ACCOUNTING',
        name: 'Accounting',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    TAX: {
        id: 'TAX',
        name: 'Tax',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    RECONCILIATION: {
        id: 'RECONCILIATION',
        name: 'Reconciliation',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    CORPORATE_ACTIONS: {
        id: 'CORPORATE_ACTIONS',
        name: 'Corporate Actions',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    REPORTING: {
        id: 'REPORTING',
        name: 'Reporting',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
        requiredModules: ['INVESTMENT'],
    },
    IMPORT: {
        id: 'IMPORT',
        name: 'Import',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    INSTRUMENTS: {
        id: 'INSTRUMENTS',
        name: 'Instruments',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    FACTS: {
        id: 'FACTS',
        name: 'Facts',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    HOLDINGS: {
        id: 'HOLDINGS',
        name: 'Holdings',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    MARGIN_TRADING: {
        id: 'MARGIN_TRADING',
        name: 'Margin Trading',
        globallyAvailable: false,
        licensable: true,
        configurableByOrganization: true,
    },
    ORDER_MANAGEMENT: {
        id: 'ORDER_MANAGEMENT',
        name: 'Order Management',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    MARKET_DATA: {
        id: 'MARKET_DATA',
        name: 'Market Data',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    DATA: {
        id: 'DATA',
        name: 'Data',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
    ADMIN: {
        id: 'ADMIN',
        name: 'Administration',
        globallyAvailable: true,
        licensable: false,
        configurableByOrganization: true,
    },
    REGULATORY: {
        id: 'REGULATORY',
        name: 'Regulatory',
        globallyAvailable: true,
        licensable: true,
        configurableByOrganization: true,
    },
};
